import { Entity } from '@/store/shared/entity'

export default class AmountStatistics extends Entity<number>{
    customerId:number;
    businessGroup:string;
    chargeUserId:number;
    totalVotes:number;
    receiverAmount:number;
    customerName:string;
    chargeUser:string;
    total:number;
}